<!--Login Modal Starts-->
<div #loginModal class="modal fade auth-modal" id="login-modal" data-keyboard="false" [attr.data-midwifeid]="" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Login.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pt-5 pb-3">
              <div class="d-flex flex-column">
                <form #loginForm="ngForm" class="d-flex flex-column">
                  <span class="title mt-5 ">Login</span>

                  <!-- Email Input box -->
                  <span class="input-label mt-4 mb-2">User email</span>
                  <input class="form-control form-control-sm header-search" placeholder="User email" name="email"
                    [(ngModel)]="loginData.userEmail" #email="ngModel" required type="email" [email]="true">
                  <span *ngIf="email.invalid && email.touched" class="error-text">Please enter a valid email
                    address</span>

                  <!-- Password Input box -->
                  <span class="input-label mt-4 mb-2">Password </span>
                  <div class="input-icons">
                    <i class="fas eye-icon" [ngClass]="{'fa-eye': eye, 'fa-eye-slash': !eye}" (click)="toggle()"></i>
                    <input #pass class="form-control form-control-sm header-search" placeholder="Password"
                      type="password" [(ngModel)]="loginData.userHashPassword" minlength="6" #password="ngModel"
                      name="password" required>
                    <span *ngIf="password.invalid && password.touched" class="error-text">Please enter a valid
                      password</span>
                  </div>

                </form>
                <span *ngIf="email.valid" class="forgot-password mt-2" (click)="fetchUserInfoFromEmail()">Forgot
                  password?</span>
                <button [disabled]="loginForm.invalid || loading" (click)="login(loginModal)"
                  class="btn btn-lg btn-theme mt-4 mb-5">Login</button>

                <div *ngIf="loading" class="spinner-border loader" role="status">
                  <span class="sr-only">Loading...</span>
                </div>

                <div class="d-flex flex-row justify-content-center mt-5 dropup">
                  <span class="footer mr-2">Dont have an account?</span>
                  <span class="forgot-password dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">Signup <i class="ml-1 fas fa-chevron-down"></i></span>
                  <div class="dropdown-menu">
                    <span class="dropdown-item" (click)="navigateToSignupPregnant()">Are you pregnant ?</span>
                    <span class="dropdown-item" (click)="navigateToSignupMidwife()">Are you a midwife ?</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Login Modal Ends-->
